import { IMissionPlan } from '../missionPlan/IMissionPlan'
import { MissionPlanUiState } from '../../ui/MissionPlanUiState'
import { SimulationMode } from '@/enum/SimulationMode'
import { ISmartSimulationBase, getDefaultSmartSimulationBase, isReadyForSimulationBase } from './ISmartSimulationBase'
import { DepRecoMode } from '@/enum/DepRecoMode'
import { IMissionPlanWaypoint } from '../missionPlan/IMissionPlanWaypoint'
import { IArea } from './IArea'
import { getDefaultGliderCoverageConfig, IGliderCoverageConfig } from './IGliderCoverageConfig'
import { isReadyForSimulation } from './ISmartSimulation'

export interface ISmartSimulationCoverage extends ISmartSimulationBase {
  gliders_config: Array<IGliderCoverageConfig>
  grid_size: number
  deployment_mode: DepRecoMode
  deployment_point: number
  recovery_mode: DepRecoMode
  recovery_point: number
  coverage_area: Array<IMissionPlanWaypoint>
  exclude_areas: Array<IArea>
  resolution_time: number
}

export function getDefaultSmartSimulationCoverage({
  templateSimId = null,
  processing_mode = SimulationMode.simulator,
  mission_start_date = '',
  glider_type = 'SEAEXPLORER',
  battery_type = 'pack 18650',
  bms_type = 'neogy',
  enable_science_files = false,
  deployment_point = 0 as number,
  recovery_point = 0 as number,
  surfacing_time = 300,
  grid_size = 20,
  current_cycle = 0,
  gliders_config = [getDefaultGliderCoverageConfig()],
  deployment_mode = DepRecoMode.common,
  recovery_mode = DepRecoMode.common,
  coverage_area = [],
  exclude_areas = [],
  resolution_time = 40,
} = {}): ISmartSimulationCoverage {
  return {
    ...getDefaultSmartSimulationBase({
      templateSimId,
      processing_mode,
      mission_start_date,
      glider_type,
      battery_type,
      bms_type,
      enable_science_files,
      surfacing_time,
      current_cycle,
    }),
    grid_size,
    deployment_mode,
    deployment_point,
    recovery_mode,
    recovery_point,
    coverage_area,
    exclude_areas,
    gliders_config,
    resolution_time,
  }
}

//retourne une liste de code d'erreur si le smartSimulation n'est pas valide
//si valide pour la simulation le tableau est vide
export function isReadyForSimulationCoverage(data: ISmartSimulationCoverage | null): Array<string> {
  const simuErrorCode = isReadyForSimulationBase(data)
  //ajout des tests specifiques a la couverture

  return simuErrorCode
}
